import Vue from "vue";
import SortedTablePlugin from "vue-sorted-table";
import Paginate from "@/components/widgets/pagination.vue";
import DatePicker from 'vue2-datepicker'
import moment from 'moment'

Vue.use(SortedTablePlugin, {
  ascIcon: '<i class="mdi mdi-arrow-down"></i>',
  descIcon: '<i class="mdi mdi-arrow-up"></i>'
});

export default {
  components: { 
    DatePicker,
    Paginate },
  data() {
    return {
      busy: false,
      perPage: 25,
      sortBy: 'sale_date',
      sortDesc: true,
      currentPage: 1,
      currentData: {},       // สำหรับ Paginate
      totalItem: 0,
      apiStatus: 'ไม่พบข้อมูล',

      // ตัวกรอง
      filters: {
        start: moment().format('YYYY-MM-DD'),
        // end: this._d2(new Date()),
        branch_id: null
      },

      // รายการสาขา (ถ้ามี endpoint)
      branches: [],

      // ฟิลด์ของตาราง
      fields: [
        { key: "sale_date",    label: "วันที่",           thClass: "text-xs-1/2 font-weight-bold", tdClass: "text-xs-1/2", sortable: true },
        { key: "branch_name",  label: "สาขา",            thClass: "text-xs-1/2 font-weight-bold", tdClass: "text-gray-400 font-weight-light text-xs-1/2", sortable: true },
        { key: "total_orders", label: "จำนวนออเดอร์",    thClass: "text-xs-1/2 font-weight-bold text-right", tdClass: "text-gray-400 text-right font-weight-light text-xs-1/2", sortable: true },
        { key: "total_sales",  label: "ยอดขายรวม",       thClass: "text-xs-1/2 font-weight-bold text-right", tdClass: "text-gray-400 text-right font-weight-light text-xs-1/2", sortable: true },
      ],

      // ข้อมูลตารางหลัก (รายวัน × สาขา)
      items: [],

      // สรุปรวมทั้งระบบรายวัน (ตารางเล็กด้านล่าง)
      dailyTotals: []
    };
  },
  computed: {
    rows() {
      return this.items.length;
    },
    sumTotalOrders() {
      return this.items.reduce((n, it) => n + Number(it.total_orders || 0), 0);
    },
    sumTotalSales() {
      return this.items.reduce((n, it) => n + Number(it.total_sales || 0), 0);
    }
  },
  mounted() {
    this.fetchBranches();
    this.onInitData(1);
  },
  methods: {
    // ===== utils =====
    _d2(d) {
      // yyyy-mm-dd
      const pad = n => (n<10?'0':'') + n;
      return `${d.getFullYear()}-${pad(d.getMonth()+1)}-${pad(d.getDate())}`;
    },
    _formatDateTH(yyyy_mm_dd) {
      if (!yyyy_mm_dd) return '-';
      const [y,m,d] = yyyy_mm_dd.split('-').map(Number);
      return `${d.toString().padStart(2,'0')}/${m.toString().padStart(2,'0')}/${y+543}`;
    },
    _money(n) {
      return Number(n||0).toLocaleString('th-TH', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    },

    // ===== data loading =====
    async fetchBranches() {
      try {
        const items = [];
        const res2 = await this.$axios.get('/api/v1/branches');
        const arr = Array.isArray(res2?.data) ? res2.data : (res2?.data?.data || []);
        for (const b of arr) items.push({ id: b.id, name: b.name });
        // sort ตามชื่อ
        items.sort((a, b) => (a.name || '').localeCompare(b.name || '', 'th'));
        this.branches = items;
      } catch (_e) {
        this.branches = [];
      }
    },

    async onInitData(page) {
      try {
        this.busy = true;
        this.apiStatus = 'กำลังค้นหาข้อมูล..';

        this.currentPage = page || 1;

        const params = {
          start: moment(this.filters.start).format('YYYY-MM-DD'),
          // end: this.filters.end,
          branch_id: this.filters.branch_id,
          page: this.currentPage,
          per_page: this.perPage
        };

        const result = await this.$axios.get('/api/v1/report/daily-sales', { params });

        // รองรับทั้งแบบ array (no pagination) และแบบ Laravel pagination
        const payload = result?.data || result;

        if (payload && Array.isArray(payload.by_branch_per_day)) {
          // ไม่มี server pagination -> map ให้ items
          const list = payload.by_branch_per_day.map((r, idx) => ({
            _key: `${r.sale_date}-${r.branch_id}-${idx}`,
            sale_date: r.sale_date,
            branch_id: Number(r.branch_id), // สำคัญ: API ส่ง string
            branch_name: (r.branch_detail && r.branch_detail.name)
                      || (r.branch && r.branch.name)
                      || r.branch_name
                      || `#${r.branch_id}`,
            total_orders: Number(r.total_orders || 0),
            total_sales: Number(r.total_sales || 0),
          }));

          // จัดหน้าแบบ client-side แต่ทำโครงสร้าง currentData ให้ Paginate ใช้ได้
          this.totalItem = list.length;

          // slice ตามหน้า
          const startIdx = (this.currentPage - 1) * this.perPage;
          const pageItems = list.slice(startIdx, startIdx + this.perPage);

          this.items = pageItems;

          this.currentData = {
            data: pageItems,
            total: this.totalItem,
            per_page: this.perPage,
            current_page: this.currentPage,
            last_page: Math.max(1, Math.ceil(this.totalItem / this.perPage))
          };

          // ตารางรวมรายวัน (ทุกสาขา)
          this.dailyTotals = (payload.all_branches_per_day || []).map((r, i) => ({
            _key: `tot-${r.sale_date}-${i}`,
            sale_date: r.sale_date,
            total_orders: Number(r.total_orders || 0),
            total_sales: Number(r.total_sales || 0),
          }));

        } else if (payload && Array.isArray(payload.data)) {
          // มี server pagination อยู่แล้ว
          const pageItems = payload.data.map((r, idx) => ({
            _key: `${r.sale_date}-${r.branch_id}-${idx}`,
            sale_date: r.sale_date,
            branch_id: Number(r.branch_id),
            branch_name: (r.branch_detail && r.branch_detail.name)
                      || (r.branch && r.branch.name)
                      || r.branch_name
                      || `#${r.branch_id}`,
            total_orders: Number(r.total_orders || 0),
            total_sales: Number(r.total_sales || 0),
          }));

          this.items = pageItems;
          this.currentData = {
            data: pageItems,
            total: payload.total || pageItems.length,
            per_page: payload.per_page || this.perPage,
            current_page: payload.current_page || this.currentPage,
            last_page: payload.last_page || 1
          };
          this.totalItem = this.currentData.total;

          this.dailyTotals = Array.isArray(payload.all_branches_per_day)
            ? payload.all_branches_per_day.map((r, i) => ({
                _key: `tot-${r.sale_date}-${i}`,
                sale_date: r.sale_date,
                total_orders: Number(r.total_orders || 0),
                total_sales: Number(r.total_sales || 0),
              }))
            : [];
        } else {
          this.items = [];
          this.currentData = { data: [], total: 0, per_page: this.perPage, current_page: 1, last_page: 1 };
          this.totalItem = 0;
          this.dailyTotals = [];
        }

        this.apiStatus = this.items.length ? '' : 'ไม่พบข้อมูล';
      } catch (error) {
        this.items = [];
        this.currentData = { data: [], total: 0, per_page: this.perPage, current_page: 1, last_page: 1 };
        this.totalItem = 0;
        this.dailyTotals = [];
        this.apiStatus = 'ไม่พบข้อมูล';
        this.onExceptionHandler?.(error?.response?.data?.message || error?.message || 'เกิดข้อผิดพลาด');
      } finally {
        this.busy = false;
      }
    },

    // event จาก <Paginate />
    async onInitDataWithEvent(page) {
      await this.onInitData(page);
    },

    async onApplyFilters() {
      this.currentPage = 1;
      await this.onInitData(this.currentPage);
    },

    async onResetFilters() {
      this.filters.start = this._d2(new Date(Date.now() - 29*24*60*60*1000));
      this.filters.end = this._d2(new Date());
      this.filters.branch_id = null;
      await this.onApplyFilters();
    },

    // ===== Export =====
    async Export() {
      try {
        this.loading = true;

        const payload = {
          start: this.filters.start,
          end: this.filters.end,
          branch_id: this.filters.branch_id
        };

        const response = await this.$axios.post(
          `${Vue.prototype.$host || ''}/reports/daily-sales/export`,
          payload,
          { responseType: 'blob' }
        );

        const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        const ts = new Date().toLocaleDateString("th-TH", { year: "numeric", month: "short", day: "numeric" });

        link.href = url;
        link.setAttribute('download', `รายงานยอดขายรายวัน_${ts}.xlsx`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);

      } catch (error) {
        // fallback CSV ฝั่ง client
        try {
          const header = ['วันที่','สาขา','จำนวนออเดอร์','ยอดขายรวม'];
          const rows = this.items.map(i => [
            this._formatDateTH(i.sale_date),
            i.branch_name || '',
            i.total_orders,
            i.total_sales
          ]);
          const csv = [header, ...rows].map(r => r.map(v => `"${String(v).replace(/"/g,'""')}"`).join(',')).join('\n');
          const blob = new Blob(["\ufeff"+csv], { type: 'text/csv;charset=utf-8;' });
          const url = URL.createObjectURL(blob);
          const a = document.createElement('a');
          const ts = new Date().toISOString().slice(0,10);
          a.href = url;
          a.download = `รายงานยอดขายรายวัน_${ts}.csv`;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          URL.revokeObjectURL(url);
        } catch (_e) {
          this.onExceptionHandler?.(error?.response?.data?.message || error?.message || 'ไม่สามารถส่งออกไฟล์ได้');
        }
      } finally {
        this.loading = false;
      }
    },
    formatDateTH(dateStr) {
        return this._formatDateTH(dateStr);
      },
      money(n) {
        return this._money(n);
      },
  }
};
